import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { AxiosPromise, AxiosRequestConfig } from 'axios'
import { ResponseData } from 'request'
import {
  VoiceListQuery,
  VoiceListResponse,
  AddVoiceData,
  VoiceItem,
  UpdateVoiceData,
} from './index.type'
import { cookRequestParams } from '@/common/request'

/**
 * 音色列表
 */
export function voiceList(
  data?: Partial<VoiceListQuery>,
  config?: AxiosRequestConfig,
): AxiosPromise<ResponseData<VoiceListResponse>> {
  return request({
    url: `${v2Host}/ai/voices/list`,
    method: 'get',
    params: cookRequestParams(data),
    ...config,
  })
}

/**
 * 添加音色
 */
export function addVoice(
  data: AddVoiceData,
): AxiosPromise<ResponseData<VoiceItem['id']>> {
  return request({
    url: `${v2Host}/ai/voices/add`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

/**
 * 删除音色
 */
export function deleteVoice(data: {
  id: VoiceItem['id']
}): AxiosPromise<ResponseData<Record<string, never>>> {
  return request({
    url: `${v2Host}/ai/voices/delete`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

/**
 * 编辑音色
 */
export function updateVoice(
  data: UpdateVoiceData,
): AxiosPromise<ResponseData<VoiceItem['id']>> {
  return request({
    url: `${v2Host}/ai/voices/update`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}
